import { createSelector } from "reselect";

const activeThreadSelector = (state: TReduxState) => state.root.entities.thread;

export const getThreadInput = createSelector(
  activeThreadSelector,
  (data) => data.input
);
export const getThreadList = createSelector(
  activeThreadSelector,
  (data) => data.threadList
);
export const getThreadLoading = createSelector(
  activeThreadSelector,
  (data) => data.loading
);
export const getThreadPID = createSelector(
  activeThreadSelector,
  (data) => data.pid
);
export const getRiskCheckerInput = createSelector(
  activeThreadSelector,
  (data) => data.riskCheckerInput
);
export const getRiskcheckerSelectedFiles = createSelector(
  activeThreadSelector,
  (data) => data.riskcheckerSelectedFiles
);
export const getRiskcheckerSelectedFilesURLs = createSelector(
  activeThreadSelector,
  (data) => data.riskcheckerSelectedFilesURLs
);
export const getRiskcheckerSelectedField = createSelector(
  activeThreadSelector,
  (data) => data.riskcheckerSelectedField
);
export const getRiskcheckerUploadLoading = createSelector(
  activeThreadSelector,
  (data) => data.riskCheckerFileUploading
);
export const getImagePopup = createSelector(
  activeThreadSelector,
  (data) => data.imagePopupState
);
export const getChatThreadId = createSelector(
  activeThreadSelector,
  (data) => data.threadId
);
export const getThreadPage = createSelector(
  activeThreadSelector,
  (data) => data.threadPage
);
export const getDoazGptUploadLoading = createSelector(
  activeThreadSelector,
  (data) => data.doazGptFileUploading
);
export const getDoazGptSelectedFiles = createSelector(
  activeThreadSelector,
  (data) => data.doazGptSelectedFiles
);
export const getDoazGptSelectedFilesURLs = createSelector(
  activeThreadSelector,
  (data) => data.doazGptSelectedFilesURLs
);
export const getIsEditing = createSelector(
  activeThreadSelector,
  (data) => data.isEditing
);
export const getEditState = createSelector(
  activeThreadSelector,
  (data) => data.editState
);
export const getChatFeedbackState = createSelector(
  activeThreadSelector,
  (data) => data.chatFeedback
);
export const getThreadChatId = createSelector(
  activeThreadSelector,
  (data) => data.chatId
);
export const getThreadChatHistory = createSelector(
  activeThreadSelector,
  (data) => data.chat_history
);
export const getConGptSelectedDocs = createSelector(
  activeThreadSelector,
  (data) => data.conGptSelectedDocs
);
export const getSelectedModel = createSelector(
  activeThreadSelector,
  (data) => data.selectedModel
);
